
import * as React from "react";
import classNames from 'classnames';

import logo from '../assets/areaway_claim.jpg';
import {
    Container,
    Grid,
    Button
} from "tabler-react";

import {
    NavLink,
} from 'react-router-dom';


import './Header.css';

interface HelloMessageProps {
    name: string;
}
interface IState {
    isOpened?: boolean;
}

export default class AreaWayHeader extends React.Component<HelloMessageProps, IState>{
   
    constructor(props: HelloMessageProps){
        super(props);
        this.state = { isOpened: false };
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick(){
        this.setState(state => ({
            isOpened: !state.isOpened
          }));
    }

    
    render() {
        return (
            <div className="areaway-header">
                <div className="areaway-header-container">
                    <div className="areaway-header-container-lineup" />
                    <Container className="areaway-header-container-logo">
                        <Grid.Row>
                            <Grid.Col width={10} sm={8} md={7} lg={4}>
                                <div className="areaway-header-container-logo-logo">
                                    <img src={logo} className="areaway-header-container-logo-logo" alt="AreaWay" />
                                </div>
                            </Grid.Col>
                            <Grid.Col width={2} sm={4} md={5} lg={8}>
                                <Button className="burger-btn d-block d-sm-none" social="bars" square size="xl" color="primary" onClick={this.handleClick}/>
                            </Grid.Col>
                        </Grid.Row>
                    </Container>
                    <div className={classNames("navbar-collapse d-sm-none",{"collapse":!this.state.isOpened,"d-block":this.state.isOpened}  )}  id="navbarSupportedContent1">
                        <ul className="navbar-nav mr-auto">
                            <NavLink exact activeClassName="active" to="/">
                                <li className="nav-item" onClick={this.handleClick}>
                                    <Container>
                                        <Grid.Col>
                                            Homepage
                                    </Grid.Col>
                                    </Container>
                                </li>
                            </NavLink>
                            <NavLink exact activeClassName="active" to="/Leistungen">
                                <li className="nav-item" onClick={this.handleClick}>
                                    <Container>
                                        <Grid.Col>
                                            Leistungen
                                    </Grid.Col>
                                    </Container>
                                </li>
                            </NavLink>
                            <NavLink exact activeClassName="active" to="/Curriculum Vitae">
                                <li className="nav-item" onClick={this.handleClick}>
                                    <Container>
                                        <Grid.Col>
                                            Curriculum Vitae
                                    </Grid.Col>
                                    </Container>
                                </li>
                            </NavLink>
                            <NavLink exact activeClassName="active" to="/Impressum">
                                <li className="nav-item" onClick={this.handleClick}>
                                    <Container>
                                        <Grid.Col>
                                        Impressum
                                    </Grid.Col>
                                    </Container>
                                </li>
                            </NavLink>
                            <NavLink exact activeClassName="active" to="/Datenschutz">
                                <li className="nav-item"onClick={this.handleClick}>
                                    <Container>
                                        <Grid.Col>
                                            Datenschutz
                                    </Grid.Col>
                                    </Container>
                                </li>
                            </NavLink>
                        </ul>
                    </div>
                    <div className="areaway-header-container-nav">
                        <Container className="areaway-header-container-nav-header clearfix d-none d-sm-block">
                            <NavLink exact activeClassName="active" to="/">
                                <div className="nav-item">Homepage</div>
                            </NavLink>
                            <NavLink exact activeClassName="active" to="/Leistungen">
                                <div className="nav-item">Leistungen</div>
                            </NavLink>
                            <NavLink exact activeClassName="active" to="/Curriculum Vitae">
                                <div className="nav-item">Curriculum Vitae</div>
                            </NavLink>
                        </Container>
                    </div>
                </div>
            </div>
        );
    }
}